import { BlockId } from 'src/game/minigame/match2-timestep/game/defs/block';
import { Match2PowerupType } from '../match2.ruleset';
import RawWaterBalloonsGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_water_balloons.json';
import RawFirecrackersGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_firecrackers.json';
import RawLollipopsGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_lollipops.json';
import RawMovesRemainingGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_remaining_moves.json';
import RawLevelCompletesGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_levels.json';
import RawStreakLevelCompletesGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_streak_levels.json';
import RawBasicBlocksGoalData from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs_basic_blocks.json';
import { Match2DailyChallengesConfigs } from 'src/replicant/data/match2/dailyChallenges/Match2DailyChallengesConfigs.schema';

export type Match2DailyChallengeId =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday';

export type Match2DailyChallengeType =
  | 'powerBlocks'
  | 'movesRemaining'
  | 'levelCompletes'
  | 'basicBlocks';

export type Match2PowerBlocksGoal = {
  type: 'powerBlocks';
  subType: Match2PowerupType;
};
export type Match2MovesRemainingGoal = { type: 'movesRemaining' };
export type Match2LevelCompletesGoal = {
  type: 'levelCompletes';
  subType: 'default' | 'maxBuruStreak';
};
export type Match2BasicBlocksGoal = {
  type: 'basicBlocks';
  subType: BlockId;
};
export type Match2DailyChallengeGoal =
  | Match2PowerBlocksGoal
  | Match2MovesRemainingGoal
  | Match2LevelCompletesGoal
  | Match2BasicBlocksGoal;

type Match2DailyChallenge = {
  id: Match2DailyChallengeId;
  goal: Match2DailyChallengeGoal;
  configs: Match2DailyChallengesConfigs;
};

export const match2DailyChallenges: Match2DailyChallenge[] = [
  {
    id: 'sunday',
    goal: { type: 'levelCompletes', subType: 'default' },
    configs: RawLevelCompletesGoalData,
  },
  {
    id: 'monday',
    goal: { type: 'powerBlocks', subType: 'bomb' },
    configs: RawWaterBalloonsGoalData,
  },
  {
    id: 'tuesday',
    goal: { type: 'movesRemaining' },
    configs: RawMovesRemainingGoalData,
  },
  {
    id: 'wednesday',
    goal: { type: 'powerBlocks', subType: 'cube' },
    configs: RawLollipopsGoalData,
  },
  {
    id: 'thursday',
    goal: { type: 'levelCompletes', subType: 'maxBuruStreak' },
    configs: RawStreakLevelCompletesGoalData,
  },
  {
    id: 'friday',
    goal: { type: 'basicBlocks', subType: 'basicYellow' },
    configs: RawBasicBlocksGoalData,
  },
  {
    id: 'saturday',
    goal: { type: 'powerBlocks', subType: 'rocket' },
    configs: RawFirecrackersGoalData,
  },
];
